module.exports = __webpack_public_path__ + "img/banner-1.4013ef48.png";